<template>
  <div class="iframe-page">
    <section class="panel" v-if="showPulse">
      <Pulse />
    </section>
    <section class="panel" v-if="showFace">
      <FaceSimpleView />
    </section>
  </div>
</template>

<script>
import Pulse from '@/views/pulse'
import FaceSimpleView from '@/views/faceSimple'
import { getCodeProjectCg } from '@/api/signUp'
export default {
  name: 'IndexView',
  components: {
    Pulse,
    FaceSimpleView
  },
  data() {
    return {
      id: '',
      type: '1',
    };
  },
  computed: {
    normalizedType() {
      return String(this.type || '')
    },
    showPulse() {
      return this.normalizedType === '1' || this.normalizedType === '3'
    },
    showFace() {
      return this.normalizedType === '2' || this.normalizedType === '3'
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(){
      console.log(this.$route.query.id)
      this.id = this.$route.query.id;
      getCodeProjectCg({
        id: this.id
      }).then(res => {
        console.log(res)
        if (res.data.code == 200) {
            // 类型：1 脉诊，2 面诊，3 同时展示
            this.type = res.data.data.type
        }
      })
     

     
    }
  }
}
</script>

<style scoped>
.iframe-page {
  min-height: 100vh;
}

.panel {
  min-height: 100vh;
}
</style>
